'use client';

import styles from '../styles.module.scss';
import type { Component } from './types';

export const ConsumerRatingScoreContent: Component = ({
  score,
  label,
}) => {
  const formattedOverallRate = (
    rate?: number | null,
  ) => (rate ? rate.toFixed(1) : '0.0');

  return (
    <div
      className={styles.containerRatingBlock}>
      <div className={styles.consumerRatingScore}>
        {formattedOverallRate(score)}
      </div>
      <div className={styles.consumerRatingText}>
        {label}
      </div>
    </div>
  );
};
